import React from "react";
import { Grid, Box, IconButton } from "@material-ui/core";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import styled from "styled-components";
import DoneIcon from "@material-ui/icons/Done";

export function ColorRow({
  color,
  name,
  onAddLabel,
  onRemoveLabel,
  onEditLabel,
  isLabelSelected,
}) {
  // const [isSelected, setSelected] = useState(false);
  const handleSelection = () => {
    // setSelected(!isLabelSelected);
    if (!isLabelSelected) onAddLabel();
    else onRemoveLabel();
  };
  return (
    <Grid container alignItems="center" justify="space-around" spacing={1}>
      <Grid item md={10} xs={9}>
        <Color
          color={color}
          onClick={handleSelection}
          isSelected={isLabelSelected}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            height={"27px"}
          >
            <Box width={1}>{name}</Box>
            {isLabelSelected && (
              <IconButton size="small" style={{ padding: "2px" }}>
                <DoneIcon size="small" />
              </IconButton>
            )}
          </Box>
        </Color>
      </Grid>
      <Grid item md={2}>
        <IconButton size="small" onClick={onEditLabel}>
          <EditOutlinedIcon />
        </IconButton>
      </Grid>
    </Grid>
  );
}

export const Color = styled.div`
  background-color: ${(props) => props.color};
  color: #fff;
  width: 100%;
  margin: 2px;
  border-radius: 2px;
  padding: 0px 5px;
  cursor: pointer;
  filter: ${(props) => (props.isSelected ? "brightness(85%)" : "none")};
  &:hover {
    /* opacity: 0.5; */
    border-left: 2px solid ${(props) => props.color};
    /* filter: brightness(85%); */
  }
`;
